import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import { getOrgApp } from "../helpers/get-orgApp";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

var randomVolumes = [2, 4, 8];

export const allVolumes = async () => {
  let volumes = [];
  let orgAppDetails = await getOrgApp();
  let accounts = await getAccounts();

  
  for (var i = 0; i < 35; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    const RegionCode = faker.helpers.arrayElement(regionCodes);
    
    var volume = {
      AccountNumber: faker.helpers.arrayElement(accounts),
      InstanceId: "i-" + faker.random.alphaNumeric(15),
      Tags: [],
      VolumeType: "gp2",
      RegionCode,
      ARN: `arn:aws::volume:${RegionCode}:${faker.random.alphaNumeric(15)}`,      
      State: "in-use",
      VolumeSize: faker.helpers.arrayElement(randomVolumes),
      UpdatedAt: "2019-05-07T09:04:34Z",
      ResourceId: "vol-" + faker.random.alphaNumeric(15),
      IsDeleted: 0,
      ResourceName: "MontyCloud-Vol-" + faker.random.alphaNumeric(8),
      VolumeName: "Volume-" + faker.random.alphaNumeric(6),
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      DepartmentId: selectedDept.deptId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
    };
    volume.AvailabilityZone = volume.RegionCode + "d";
    volumes.push(volume);
  }
  return volumes;
};

export const volumeData = (volume) => {
  return {
    AvailabilityZone: volume.AvailabilityZone,
    Attachments: [
      {
        AttachTime: volume.UpdatedAt,
        InstanceId: volume.InstanceId,
        ResourceId: volume.ResourceId,
        State: volume.State,
        DeleteOnTermination: true,
        Device: "/dev/xvda",
      },
    ],
    Encrypted: false,
    VolumeType: volume.VolumeType,
    ResourceId: volume.InstanceId,
    State: volume.State,
    Iops: 100,
    SnapshotId: "snap-" + faker.random.alphaNumeric(15),
    CreateTime: volume.UpdatedAt,
    Size: volume.VolumeSize,
  };
};
